import { render, staticRenderFns } from "./TransloadAndReturnToBase.vue?vue&type=template&id=11d070c4"
import script from "./TransloadAndReturnToBase.vue?vue&type=script&lang=js"
export * from "./TransloadAndReturnToBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports